import { lazy } from "react";
import IntlTranslation from "./intlTranslation.js";
import authorityAlls from "@/utils/authorityAlls.js";
import IconFont from "@/components/icon/index.js";
const {
	ADVERTISING_READ,
	ADVERTISING_WRITE,
	ADVERTISING_APPROVAL_READ,
	ADVERTISING_APPROVAL_WRITE,
	ANALYZER_READ,
	ANALYZER_WRITE,
	GOODS_CATEGORY_PROFESSIONAL_READ,
	GOODS_CATEGORY_PROFESSIONAL_WRITE,
	GOODS_CATEGORY_RETAIL_READ,
	GOODS_CATEGORY_RETAIL_WRITE,
	GOODS_READ,
	GOODS_WRITE,
	GOODS_PROFESSIONAL_WRITE,
	GOODS_PROFESSIONAL_READ,
	TAG_READ,
	TAG_WRITE,
	TAG_PROFESSIONAL_WRITE,
	TAG_PROFESSIONAL_READ,
	HEALTHY_HAIR_READ,
	HEALTHY_HAIR_WRITE,
	HEALTHY_HAIR_PROFESSIONAL_READ,
	HEALTHY_HAIR_PROFESSIONAL_WRITE,
	ROLE_READ,
	ROLE_WRITE,
	AUTHORITY_READ,
	AUTHORITY_WRITE,
	USER_READ,
	USER_WRITE,
	ANALYZER_PROFESSIONAL_READ,
	ANALYZER_PROFESSIONAL_WRITE,
	ADVERTISING_APPROVAL_PROFESSIONAL_READ,
	ADVERTISING_APPROVAL_PROFESSIONAL_WRITE,
	ADVERTISING_PROFESSIONAL_READ,
	ADVERTISING_PROFESSIONAL_WRITE,
	CUSTOMERS_PROFESSIONAL_WRITE,
	CUSTOMERS_PROFESSIONAL_READ,
} = authorityAlls;
const Login = lazy(() => import("@/pages/login/index.js"));
const NotFound = lazy(() => import("@/pages/notFound/index.js"));
const Layout = lazy(() => import("@/components/layout/index.js"));
const Advertisement = lazy(() => import("@/pages/advertisement/index"));
const ProfessionalAdvertisement = lazy(() => import("@/pages/advertisement/professionalAdvertisement/index"));
const RetailAdvertisement = lazy(() => import("@/pages/advertisement/retailAdvertisement/index"));
const Review = lazy(() => import("@/pages/review/index"));
const Device = lazy(() => import("@/pages/device/index"));
const Category = lazy(() => import("@/pages/category/index"));
const Professional = lazy(() => import("@/pages/category/professional/index"));
const Retail = lazy(() => import("@/pages/category/retail/index"));
const Product = lazy(() => import("@/pages/product/index"));
const ProductProfessional = lazy(() => import("@/pages/product/professional/index"));
const ProductRetail = lazy(() => import("@/pages/product/retail/index"));
const Tags = lazy(() => import("@/pages/tags/index"));
const TagsProfessional = lazy(() => import("@/pages/tags/professional/index"));
const TagsRetail = lazy(() => import("@/pages/tags/retail/index"));
const Contract = lazy(() => import("@/pages/contract/index"));
const ContractProfessional = lazy(() => import("@/pages/contract/professional/index"));
const ContractRetail = lazy(() => import("@/pages/contract/retail/index"));
const Role = lazy(() => import("@/pages/role/index"));
const User = lazy(() => import("@/pages/user/index"));
const Authority = lazy(() => import("@/pages/authority/index"));
const Unaudited = lazy(() => import("@/pages/review/unaudited/index"));
const Audited = lazy(() => import("@/pages/review/audited/index"));
const Submitted = lazy(() => import("@/pages/review/submitted/index"));
const Cookies = lazy(() => import("@/pages/cookies/index.js"));
const Protection = lazy(() => import("@/pages/protection/index.js"));
const ProtectionSalon = lazy(() => import("@/pages/protection/index-salon.js"));
const TermsUsage = lazy(() => import("@/pages/termsusage/index.js"));
const CopyrightNotice = lazy(() => import("@/pages/copyrightnotice/index.js"));
const ProfessionalDevice = lazy(() => import("@/pages/device/professionalDevice/index"));
const RetailDevice = lazy(() => import("@/pages/device/retailDevice/index"));
const ReviewProfessional = lazy(() => import("@/pages/reviewProfessional/index"));
const UnauditedProfessional = lazy(() => import("@/pages/reviewProfessional/unaudited/index"));
const AuditedProfessional = lazy(() => import("@/pages/reviewProfessional/audited/index"));
const SubmittedProfessional = lazy(() => import("@/pages/reviewProfessional/submitted/index"));
const Customers = lazy(() => import("@/pages/customers/index"));
const routes = [
	{
		path: "/login",
		component: Login,
		title: "登录页面",
	},
	{
		path: "/cookies",
		component: Cookies,
	},
	{
		path: "/protection",
		component: Protection,
	},
	{
		path: "/protectionSalon",
		component: ProtectionSalon,
	},
	{
		path: "/termsUsage",
		component: TermsUsage,
	},
	{
		path: "/copyrightNotice",
		component: CopyrightNotice,
	},

	{
		path: "/layout",
		component: Layout,
		routes: [
			{
				path: "/layout/advertisement",
				component: Advertisement,
				icon: <IconFont type="icon-advertisement" />,
				title: <IntlTranslation intlkey="advertisement" />,
				authority: [ADVERTISING_READ, ADVERTISING_WRITE, ADVERTISING_PROFESSIONAL_WRITE, ADVERTISING_PROFESSIONAL_READ],
				isOne: true,
				isChargeProfessional: true,
				isShowRoutes: false,
				routes: [
					{
						path: "/layout/advertisement/professional",
						component: ProfessionalAdvertisement,
						title: <IntlTranslation intlkey="professional" />,
						authority: [ADVERTISING_PROFESSIONAL_READ, ADVERTISING_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/advertisement/retail",
						component: RetailAdvertisement,
						title: <IntlTranslation intlkey="retail" />,
						authority: [ADVERTISING_READ, ADVERTISING_WRITE],
					},
				],
			},
			{
				path: "/layout/review/retail",
				component: Review,
				title: <IntlTranslation intlkey="retail" />,
				authority: [ADVERTISING_APPROVAL_READ, ADVERTISING_APPROVAL_WRITE],
				routes: [
					{
						path: "/layout/review/retail/unaudited",
						component: Unaudited,
						authority: [ADVERTISING_APPROVAL_READ, ADVERTISING_APPROVAL_WRITE],
						title: <IntlTranslation intlkey="unaudited" />,
					},
					{
						path: "/layout/review/retail/audited",
						component: Audited,
						authority: [ADVERTISING_APPROVAL_READ, ADVERTISING_APPROVAL_WRITE],
						title: <IntlTranslation intlkey="audited" />,
					},
					{
						path: "/layout/review/retail/submitted",
						component: Submitted,
						authority: [ADVERTISING_APPROVAL_READ, ADVERTISING_APPROVAL_WRITE],
						title: <IntlTranslation intlkey="submitted" />,
					},
				],
			},
			{
				path: "/layout/review/professional",
				component: ReviewProfessional,
				title: <IntlTranslation intlkey="professional" />,
				authority: [ADVERTISING_APPROVAL_PROFESSIONAL_READ, ADVERTISING_APPROVAL_PROFESSIONAL_WRITE],
				routes: [
					{
						path: "/layout/review/professional/unaudited",
						component: UnauditedProfessional,
						authority: [ADVERTISING_APPROVAL_PROFESSIONAL_READ, ADVERTISING_APPROVAL_PROFESSIONAL_WRITE],
						title: <IntlTranslation intlkey="unaudited" />,
					},
					{
						path: "/layout/review/professional/audited",
						component: AuditedProfessional,
						authority: [ADVERTISING_APPROVAL_PROFESSIONAL_READ, ADVERTISING_APPROVAL_PROFESSIONAL_WRITE],
						title: <IntlTranslation intlkey="audited" />,
					},
					{
						path: "/layout/review/professional/submitted",
						component: SubmittedProfessional,
						authority: [ADVERTISING_APPROVAL_PROFESSIONAL_READ, ADVERTISING_APPROVAL_PROFESSIONAL_WRITE],
						title: <IntlTranslation intlkey="submitted" />,
					},
				],
			},
			{
				path: "/layout/review",
				icon: <IconFont type="icon-review" />,
				title: <IntlTranslation intlkey="review" />,
				isOne: true,
				isShowRoutes: true,
				authority: [ADVERTISING_APPROVAL_PROFESSIONAL_READ, ADVERTISING_APPROVAL_PROFESSIONAL_WRITE, ADVERTISING_APPROVAL_READ, ADVERTISING_APPROVAL_WRITE],
				routes: [
					{
						path: "/layout/review/professional",
						component: ReviewProfessional,
						title: <IntlTranslation intlkey="professional" />,
						authority: [ADVERTISING_APPROVAL_PROFESSIONAL_READ, ADVERTISING_APPROVAL_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/review/retail",
						component: Review,
						title: <IntlTranslation intlkey="retail" />,
						authority: [ADVERTISING_APPROVAL_READ, ADVERTISING_APPROVAL_WRITE],
					},
				],
			},
			{
				path: "/layout/device",
				component: Device,
				icon: <IconFont type="icon-device" />,
				title: <IntlTranslation intlkey="device" />,
				authority: [ANALYZER_READ, ANALYZER_WRITE, ANALYZER_PROFESSIONAL_READ, ANALYZER_PROFESSIONAL_WRITE],
				isOne: true,
				isChargeProfessional: true,
				isShowRoutes: false,
				routes: [
					{
						path: "/layout/device/professional",
						component: ProfessionalDevice,
						title: <IntlTranslation intlkey="professional" />,
						authority: [ANALYZER_PROFESSIONAL_READ, ANALYZER_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/device/retail",
						component: RetailDevice,
						title: <IntlTranslation intlkey="retail" />,
						authority: [ANALYZER_READ, ANALYZER_WRITE],
					},
				],
			},
			{
				path: "/layout/goods/category",
				component: Category,
				isChargeProfessional: true,
				title: <IntlTranslation intlkey="category" />,
				authority: [GOODS_CATEGORY_PROFESSIONAL_READ, GOODS_CATEGORY_PROFESSIONAL_WRITE, GOODS_CATEGORY_RETAIL_READ, GOODS_CATEGORY_RETAIL_WRITE],
				routes: [
					{
						path: "/layout/goods/category/professional",
						component: Professional,
						title: <IntlTranslation intlkey="professional" />,
						authority: [GOODS_CATEGORY_PROFESSIONAL_READ, GOODS_CATEGORY_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/goods/category/retail",
						component: Retail,
						title: <IntlTranslation intlkey="retail" />,
						authority: [GOODS_CATEGORY_RETAIL_READ, GOODS_CATEGORY_RETAIL_WRITE],
					},
				],
			},
			{
				path: "/layout/goods/product",
				component: Product,
				isChargeProfessional: true,
				title: <IntlTranslation intlkey="product" />,
				authority: [GOODS_READ, GOODS_WRITE, GOODS_PROFESSIONAL_READ, GOODS_PROFESSIONAL_WRITE],
				routes: [
					{
						path: "/layout/goods/product/professional",
						component: ProductProfessional,
						title: <IntlTranslation intlkey="professional" />,
						authority: [GOODS_PROFESSIONAL_READ, GOODS_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/goods/product/retail",
						component: ProductRetail,
						title: <IntlTranslation intlkey="retail" />,
						authority: [GOODS_READ, GOODS_WRITE],
					},
				],
			},
			{
				path: "/layout/goods",
				title: <IntlTranslation intlkey="goods" />,
				isOne: true,
				icon: <IconFont type="icon-product" />,
				isShowRoutes: true,
				authority: [GOODS_CATEGORY_PROFESSIONAL_READ, GOODS_CATEGORY_PROFESSIONAL_WRITE, GOODS_CATEGORY_RETAIL_READ, GOODS_CATEGORY_RETAIL_WRITE, GOODS_READ, GOODS_WRITE],
				routes: [
					{
						path: "/layout/goods/category",
						component: Category,
						isShowRoutes: false,
						isChargeProfessional: true,
						title: <IntlTranslation intlkey="category" />,
						authority: [GOODS_CATEGORY_PROFESSIONAL_READ, GOODS_CATEGORY_PROFESSIONAL_WRITE, GOODS_CATEGORY_RETAIL_READ, GOODS_CATEGORY_RETAIL_WRITE],
						routes: [
							{
								path: "/layout/goods/category/professional",
								component: Professional,
								title: <IntlTranslation intlkey="professional" />,
								authority: [GOODS_CATEGORY_PROFESSIONAL_READ, GOODS_CATEGORY_PROFESSIONAL_WRITE],
							},
							{
								path: "/layout/goods/category/retail",
								component: Retail,
								title: <IntlTranslation intlkey="retail" />,
								authority: [GOODS_CATEGORY_RETAIL_READ, GOODS_CATEGORY_RETAIL_WRITE],
							},
						],
					},
					{
						path: "/layout/goods/product",
						component: Product,
						isChargeProfessional: true,
						title: <IntlTranslation intlkey="product" />,
						authority: [GOODS_READ, GOODS_WRITE, GOODS_PROFESSIONAL_READ, GOODS_PROFESSIONAL_WRITE],
						routes: [
							{
								path: "/layout/goods/product/professional",
								component: ProductProfessional,
								title: <IntlTranslation intlkey="professional" />,
								authority: [GOODS_PROFESSIONAL_READ, GOODS_PROFESSIONAL_WRITE],
							},
							{
								path: "/layout/goods/product/retail",
								component: ProductRetail,
								title: <IntlTranslation intlkey="retail" />,
								authority: [GOODS_READ, GOODS_WRITE],
							},
						],
					},
				],
			},
			{
				path: "/layout/tags",
				component: Tags,
				isChargeProfessional: true,
				isOne: true,
				isShowRoutes: false,
				icon: <IconFont type="icon-tags" />,
				title: <IntlTranslation intlkey="tags" />,
				authority: [TAG_READ, TAG_WRITE, TAG_PROFESSIONAL_WRITE, TAG_PROFESSIONAL_READ],
				routes: [
					{
						path: "/layout/tags/professional",
						component: TagsProfessional,
						title: <IntlTranslation intlkey="professional" />,
						authority: [TAG_PROFESSIONAL_READ, TAG_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/tags/retail",
						component: TagsRetail,
						title: <IntlTranslation intlkey="retail" />,
						authority: [TAG_READ, TAG_WRITE],
					},
				],
			},
			{
				path: "/layout/contract",
				component: Contract,
				isChargeProfessional: true,
				isOne: true,
				isShowRoutes: false,
				icon: <IconFont type="icon-contract" />,
				title: <IntlTranslation intlkey="contract" />,
				authority: [HEALTHY_HAIR_READ, HEALTHY_HAIR_WRITE, HEALTHY_HAIR_PROFESSIONAL_WRITE, HEALTHY_HAIR_PROFESSIONAL_READ],
				routes: [
					{
						path: "/layout/contract/professional",
						component: ContractProfessional,
						title: <IntlTranslation intlkey="professional" />,
						authority: [HEALTHY_HAIR_PROFESSIONAL_READ, HEALTHY_HAIR_PROFESSIONAL_WRITE],
					},
					{
						path: "/layout/contract/retail",
						component: ContractRetail,
						title: <IntlTranslation intlkey="retail" />,
						authority: [HEALTHY_HAIR_READ, HEALTHY_HAIR_WRITE],
					},
				],
			},
			{
				path: "/layout/system/role",
				component: Role,
				title: <IntlTranslation intlkey="role" />,
				authority: [ROLE_READ, ROLE_WRITE],
			},
			{
				path: "/layout/system/user",
				component: User,
				title: <IntlTranslation intlkey="user" />,
				authority: [USER_READ, USER_WRITE],
			},
			{
				path: "/layout/system/authority",
				component: Authority,
				title: <IntlTranslation intlkey="authority" />,
				authority: [AUTHORITY_READ, AUTHORITY_WRITE],
			},
			{
				path: "/layout/customers",
				component: Customers,
				icon: <IconFont type="icon-customer" />,
				title: <IntlTranslation intlkey="customers" />,
				authority: [CUSTOMERS_PROFESSIONAL_READ, CUSTOMERS_PROFESSIONAL_WRITE],
				isOne: true,
				isChargeProfessional: true,
				isShowRoutes: false,
			},
			{
				path: "/layout/system",
				icon: <IconFont type="icon-system" />,
				title: <IntlTranslation intlkey="system" />,
				isOne: true,
				isShowRoutes: true,
				authority: [USER_READ, USER_WRITE, ROLE_READ, ROLE_WRITE, AUTHORITY_READ, AUTHORITY_WRITE],
				routes: [
					{
						path: "/layout/system/user",
						component: User,
						title: <IntlTranslation intlkey="user" />,
						authority: [USER_READ, USER_WRITE],
					},
					{
						path: "/layout/system/role",
						component: Role,
						title: <IntlTranslation intlkey="role" />,
						authority: [ROLE_READ, ROLE_WRITE],
					},
					{
						path: "/layout/system/authority",
						component: Authority,
						title: <IntlTranslation intlkey="authority" />,
						authority: [AUTHORITY_READ, AUTHORITY_WRITE],
					},
				],
			},
			
		],
	},
	{
		path: "/404",
		component: NotFound,
		title: "404",
	},
	{
		path: null,
		redirect: "/404",
	},
];

export default routes;
